import React, { useEffect, useState } from 'react';
import './Payment.css';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import BasketItem from './BasketItem';
import CurrencyFormat from 'react-currency-format';
import axios from '../axios';
import { EmptyBasket } from '../Redux/ActionCreator';
import { db } from '../firebase';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

const mapStateToProps = (state) => {
  return {
    Basket: state.Basket,
    user: state.User,
  };
};

// --------------------------------------Fetching Peocess ------------------------------//
const mapDispatchToProps = (dispatch) => ({
  EmptyBasket: (myObject) => dispatch(EmptyBasket([myObject])),
});

function Payment(props) {
  const strip = useStripe();
  const elements = useElements();
  const history = useHistory();
  const [error, setError] = useState(null);
  // const [disable, setDisable] = useState(true);

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(true);

  //----------------------------------------------------------------------------//
  useEffect(() => {
    // generate the specoal strip secret which allows us to change a customer
    const getClientSecret = async () => {
      const response = await axios({
        methos: 'post',
        // strip expect the total in a currencies subunit
        url: `/payments/create?total=${Total * 100} `,
      });
      // ----------- taking the new secret key from the api
      setClientSecret(response.data.clientSecret);
    };
    getClientSecret();
  }, [...props.Basket]);

  console.log('secret is ', clientSecret);

  const handelSubmit = async (event) => {
    // do all the fancy strip submit
    event.preventDefault();
    setProcessing(true);

    //------------------------- client secrit -------------------------//

    const payload = await strip
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      //[paymentIntent = payment Confirmation]
      .then(({ paymentIntent }) => {
        console.log(props.user, 'user');
        // -------------- here we are going to use our firbase database -------------//
        db.collection('users')
          .doc(props.user?.user?.uid)
          .collection('orders')
          .doc(paymentIntent.id)
          .set({
            Basket: props.Basket,
            amount: paymentIntent.amount,
            created: paymentIntent.created,
          });
        setSucceeded(true);
        setError(null);
        setProcessing(false);
        console.log(props.Basket, 'iiiiiiiiiiiiiiiiiiiiiiii');
        props.EmptyBasket(props.Basket);

        history.replace('/orders');
      });
  };
  const handelChange = (event) => {
    // Listen for the changes in the CardElements
    setDisabled(event.empty);
    console.log(disabled, 'disabled');
    setError(event.error ? event.error.message : '');
  };
  const Total = 2000 * props.Basket.length;

  return (
    <div className="payment">
      <div className="payment__container">
        {/* Payment section - delivery address  */}
        <div className="payment__section ">
          <div className="payment__title">
            <h3> Delevery Address</h3>
          </div>
          <div className="payment__address">
            <p> User {props.user?.user?.email}</p>
            <p>123 React Lane</p>
            <p>los Angulas, CA</p>
          </div>
        </div>
        {/* Payment Section - Review Items */}
        <div className="payment__section ">
          <div className="payment__title">
            <h3>Reviw Items and Delivery</h3>
          </div>
          <div className="payment__items">
            {/* all the products to sjow here  */}
            {props?.Basket?.map((item, index) => {
              return (
                <BasketItem item={item} key={index} index={index}></BasketItem>
              );
            })}
          </div>
        </div>
        {/* Payment section - Payment method */}
        <div className="payment__section ">
          <div className="payment__title">
            <h3> Payment Method</h3>
          </div>
          <div className="payment__details">
            {/* Strip magic will go */}

            <form onSubmit={handelSubmit}>
              <CardElement onChange={handelChange} />
              <div className="payment__priceContaiiner">
                <CurrencyFormat
                  renderText={(value) => (
                    <h3>
                      Order Total {props.count} :<strong>{value}</strong>
                    </h3>
                  )}
                  decimalScale={2}
                  value={Total} // homework
                  displayType={'text'}
                  thousandSeperator={true}
                  prefix="$"
                />
              </div>
              <button disabled={processing || disabled || succeeded}>
                <span>{processing ? <p>Processing</p> : 'Buy Now'}</span>
              </button>
              <span>{processing ? <p> Processing </p> : 'By Now'}</span>
              {/*  Erroe SEcrion*/}
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
